/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as PNDICLLayerSpec } from '../../../../layer/preset/line/positiveAndNegativeDoubleIndicatorComparisonLine';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 图层类型名称常量
const LAYER_TYPE = 'positiveAndNegativeDoubleIndicatorComparisonLine';

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface PNDICLLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type PNDICLLayerType = StandardChartLayerSpec & PNDICLLayerSpec & PNDICLLayerTypeWithFields;

// 创建正负双指标对比折线图数据类型验证器
const validatePNDICLDataTypes = createDataTypeValidator(LAYER_TYPE, [
  { field: 'x', type: ['string', 'date'] },
  { field: 'y', type: 'number' },
  { field: 'y2', type: 'number' }
]);

// 创建正负双指标对比折线图编码验证器
const validatePNDICLEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'y2' }
]);

// 额外的检查函数 - 验证数据规则和提供布局建议
const additionalPNDICLChecks = (layer: PNDICLLayerType, data: Data) => {
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  // 检查数据量是否足够（根据图表规则，需要大于1条数据）
  if (values.length <= 1) {
    utils.logger.warn(
      'warning',
      `The "${LAYER_TYPE}" chart requires more than 1 data point for comparison`
    );
    layer.__isEncodingValid = false;
  }

  // 提示说明：双网格布局需要足够的容器高度
  utils.logger.info(
    'info',
    `The "${LAYER_TYPE}" chart works best with a container height of at least 400px`
  );
};

// 创建并导出正负双指标对比折线图处理器
export const positiveAndNegativeDoubleIndicatorComparisonLine =
  createLayerProcessor<PNDICLLayerType>(
    LAYER_TYPE,
    validatePNDICLEncoding,
    validatePNDICLDataTypes,
    additionalPNDICLChecks
  );
